
import { ASSET_METADATA } from '../../asset/model/asset.metadata';
import { FirearmAssignmentStorageType, FirearmAssignmentType } from '../../firearm_assignment/model/firearm-assignment.types';
import { FirearmLifecycleStatus } from './firearm.types';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class FirearmMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('Firearm', {
      assetId: <PropertyMetadata> {
        name: 'assetId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      asset: <PropertyMetadata> {
        name: 'asset',
        type: 'Asset',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.OneToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSET_METADATA;
        },
        byReference: false,
        unique: false
      },
      calibre: <PropertyMetadata> {
        name: 'calibre',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      currentAssignmentEmail: <PropertyMetadata> {
        name: 'currentAssignmentEmail',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      currentAssignmentFirearmAssignmentStorageType: <PropertyMetadata> {
        name: 'currentAssignmentFirearmAssignmentStorageType',
        type: 'FirearmAssignmentStorageType',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      currentAssignmentFirearmAssignmentType: <PropertyMetadata> {
        name: 'currentAssignmentFirearmAssignmentType',
        type: 'FirearmAssignmentType',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      currentlyAssignable: <PropertyMetadata> {
        name: 'currentlyAssignable',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      currentlyAssigned: <PropertyMetadata> {
        name: 'currentlyAssigned',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      firearmPoolExisting: <PropertyMetadata> {
        name: 'firearmPoolExisting',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      firearmType: <PropertyMetadata> {
        name: 'firearmType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      importDataMap: <PropertyMetadata> {
        name: 'importDataMap',
        type: '{ [id: string]: any; }',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lifecycleState: <PropertyMetadata> {
        name: 'lifecycleState',
        type: 'FirearmLifecycleStatus',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      personalFirearm: <PropertyMetadata> {
        name: 'personalFirearm',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      poolFirearm: <PropertyMetadata> {
        name: 'poolFirearm',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: true,
        readable: true,
        writeable: false,
        unique: false
      },
      suspended: <PropertyMetadata> {
        name: 'suspended',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.assetId;
    return nullIfContainsNull(result);
  }
}



